import { combineReducers } from 'redux';
import { apiValidationErrorSlice } from './common/apiValidationErrorSlice';
import { heroMetaDataSlice } from '~/pages/HeroSaga/heroMetaDataSlice';
import { heroSlice } from '~/pages/HeroSaga/Hero/heroSlice';
import { familiarSlice } from '~/pages/HeroSaga/Familiar/familiarSlice';
import { rankSlice } from '~/pages/HeroSaga/Rank/rankSlice';
import { passiveSlice } from '~/pages/HeroSaga/Passive/passiveSlice';
import { basicStatSlice } from '~/pages/HeroSaga/BasicStat/basicStatSlice';
import { equipmentSlice } from '~/pages/HeroSaga/Equipment/equipmentSlice';
import { diceSlice } from '~/pages/HeroSaga/Dice/diceSlice';
import { alignmentSlice } from '~/pages/HeroSaga/Alignment/alignmentSlice';
import { boonSlice } from '~/pages/HeroSaga/Boon/boonSlice';
import { traitSlice } from '~/pages/HeroSaga/Trait/traitSlice';

export const heroSagaReducers = combineReducers({
    apiValidationError: apiValidationErrorSlice.reducer,
    heroMetaData: heroMetaDataSlice.reducer,
    hero: heroSlice.reducer,
    familiar: familiarSlice.reducer,
    rank: rankSlice.reducer,
    passive: passiveSlice.reducer,
    basicStat: basicStatSlice.reducer,
    equipment: equipmentSlice.reducer,
    dice: diceSlice.reducer,
    alignment: alignmentSlice.reducer,
    boon: boonSlice.reducer,
    trait: traitSlice.reducer,
});
